<template>
  <div class="height1">
    <bread></bread>
    <div class="center-content">
      <el-button class="typeBtn" :type="item.value == searchForm.states ? 'primary' : 'info'" v-for="(item, index) in statusOption" @click="changeType(item, index)" :key="index">{{ item.label }}</el-button>
      <div class="iq-card-body">
        <div class="table-top">
          <div class="iq-search-bar">
            <el-form :model="searchForm" :inline="true">
              <el-form-item>
                <el-date-picker v-model="searchForm.datepicker" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions0" size="small" style="margin-right: 10px; width: 260px" @change="Search" clearable> </el-date-picker>
              </el-form-item>
              <el-form-item v-if="searchForm.states == 5">
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    searchForm.star = 0;
                    Search();
                  "
                  plain
                  >全部</el-button
                >
              </el-form-item>
              <el-form-item v-if="searchForm.states == 5">
                <el-rate v-model="searchForm.star" text-color="#ff9900" show-text :texts="texts" @change="Search"> </el-rate>
              </el-form-item>
              <el-form-item label="" v-if="searchForm.states != 5">
                <el-select v-model="searchForm.payType" style="width: 100%" placeholder="支付方式" size="small" @change="Search">
                  <el-option v-for="item in optionsPayType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" v-if="searchForm.states != 5">
                <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="订单号/患者名称" @keyup.enter.native="Search"></el-input>
              </el-form-item>
              <el-form-item label="" v-else>
                <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="" @keyup.enter.native="Search"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="Search()">搜索</el-button>
              </el-form-item>
              <!-- <el-form-item>
                <download-excel v-if="DataCount" :fields="json_fields" :fetch="fetchData" worksheet="My Worksheet" :header="title" :name="`${title}_All.xls`" class="excel">
                  <el-button type="danger" size="mini" class="el-icon-download">导出</el-button>
                </download-excel>
              </el-form-item> -->
            </el-form>
          </div>
        </div>
        <el-table :data="tableData" stripe height="calc(100% - 80px)" :default-expand-all="true" style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" v-if="searchForm.states == 5">
          <el-table-column prop="orderNumber" label="订单编号"> </el-table-column>
          <el-table-column prop="userName" label="用户" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.userName }}</div>
              <div>{{ scope.row.userPhone }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="patientName" label="患者" align="center"> </el-table-column>
          <el-table-column prop="doctorName" label="医生" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.doctorName }}</div>
              <div>{{ scope.row.doctorPhone }}</div>
            </template>
          </el-table-column>
          <el-table-column label="综合评价" align="center" sortable>
            <template slot-scope="scope">
              <el-rate v-model="scope.row.star" text-color="#ff9900" disabled show-text :texts="texts"> </el-rate>
            </template>
          </el-table-column>
          <el-table-column prop="payMoney" label="订单金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.payMoney?.toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付方式" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.payType == 0">余额</p>
              <p v-if="scope.row.payType == 1">微信</p>
              <p v-if="scope.row.payType == 2">支付宝</p>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="下单时间" width="160px" align="center" sortable>
            <template slot-scope="scope">
              <p>{{ scope.row.createTime | timefilters }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="paySuccessTime" label="支付时间" width="160px" align="center" sortable>
            <template slot-scope="scope">
              <p>{{ scope.row.paySuccessTime | timefilters }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="!scope.row.replyContent" class="primary optionBtn" @click="ReplyBtn(scope.row)">回复</span>
              <span v-else class="info optionBtn">已回复</span>
              <span class="danger optionBtn" @click="delBtn(scope.row)">删除</span>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding: 0 55px; width: calc(100% - 110px)">
                <div class="flex-start">
                  <div style="margin-right: 10px">问诊结果:</div>
                  <el-rate v-model="scope.row.consultationResult" text-color="#ff9900" disabled show-text :texts="texts1" :max="4"> </el-rate>
                </div>
                <div class="flex-start">
                  <div style="margin-right: 10px">服务态度:</div>
                  <el-rate v-model="scope.row.serviceAttitude" text-color="#ff9900" disabled show-text :texts="texts1" :max="4"> </el-rate>
                </div>
                <div class="flex-start">
                  <div style="margin-right: 10px">响应时间:</div>
                  <el-rate v-model="scope.row.responseTime" text-color="#ff9900" disabled show-text :texts="texts2" :max="4"> </el-rate>
                </div>
                <div>
                  <div style="color: red; margin-right: 20px">用户{{ scope.row.userName }}：</div>
                  <div>{{ scope.row.content || "" }}</div>

                  <div style="color: red; margin-right: 20px; margin-top: 0" v-if="scope.row.replyContent">医生{{ scope.row.doctorName }}回复：</div>
                  <div>{{ scope.row.replyContent || "" }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" height="calc(100% - 90px)" v-else>
          <el-table-column prop="orderNumber" label="订单编号"></el-table-column>
          <el-table-column prop="userName" label="用户账号" width="110" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.userName }}</p>
              <p>{{ scope.row.userPhone }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="patientName" label="患者" align="center"> </el-table-column>
          <el-table-column prop="diseaseDiagnose" label="患者病症" align="center"></el-table-column>
          <el-table-column prop="doctorName" label="医生" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.doctorName }}</p>
              <p>{{ scope.row.doctorPhone }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="totalMoney" label="订单金额(元)" align="center">
            <template slot-scope="scope">
              {{ scope.row.totalMoney.toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付方式" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.payType == 0">余额</p>
              <p v-if="scope.row.payType == 1">微信</p>
              <p v-if="scope.row.payType == 2">支付宝</p>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="订单状态" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.state == 0">待支付</p>
              <p v-if="scope.row.state == 1">待接诊</p>
              <p v-if="scope.row.state == 2">接诊中</p>
              <p v-if="scope.row.state == 3">已完成</p>
              <p v-if="scope.row.state == -1">已取消</p>
              <p v-if="scope.row.state == -2">已退款</p>
              <p v-if="scope.row.state == -3">医生拒绝接诊</p>
              <p v-if="scope.row.state == -4">删除</p>
              <p v-if="scope.row.state == 4">已评价</p>
            </template>
          </el-table-column>
          <el-table-column prop="addTime" label="下单时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.addTime | timefilters }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="250px" v-if="searchForm.states != -999">
            <template slot-scope="scope">
              <span class="info optionBtn" @click="toOrderInfo(scope.row)">详情</span>
              <span class="primary optionBtn" @click="toConfirm(scope.row)" v-if="scope.row.state == 1 && isChatDiseaseUser">确认接诊</span>
              <template v-if="scope.row.state == 2">
                <span class="primary optionBtn" @click="toContact(scope.row)" v-if="scope.row.doctorFinishState == 0">联系患者</span>
                <span class="primary optionBtn" @click="toContact(scope.row)" v-if="scope.row.doctorFinishState == 1 && scope.row.userFinishState == 2">再次联系患者</span>
              </template>
              <span class="danger optionBtn" @click="toRefund(scope.row)" v-if="scope.row.state == 1 && isChatDiseaseUser">拒绝接诊</span>
              <span class="danger optionBtn" @click="toRefund(scope.row)" v-if="scope.row.state == 2">终止问诊</span>
            </template>
          </el-table-column>
          <el-table-column type="expand" v-if="searchForm.states == -3">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="24">
                  <span style="color: #fd403b">拒绝原因：{{ scope.row.refundRefuseReson }}</span>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="changePage" :page-size="pageSize" :current-page="pageIndex" :total="dataTotal" layout="total, prev, pager, next, jumper"></el-pagination>
      </div>
    </div>
    <el-dialog :title="`${refuseForm.state == 1 ? '拒绝接诊原因' : '终止接诊原因'}`" :visible.sync="refuseDialog" width="450px" :append-to-body="true" :z-index="99999">
      <el-form class="dialog-form" :model="refuseForm" ref="refuseForm" :rules="rules" :label-width="formLabelWidth">
        <el-form-item prop="refuseReson">
          <el-input v-model="refuseForm.refuseReson" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CloseBtn('refuseForm')">取 消</el-button>
        <el-button type="primary" @click="SaveBtn('refuseForm')" :loading="isLoad">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="联系患者" :visible.sync="contactDialog" width="500px" :append-to-body="true" :z-index="99999">
      <div>
        <div style="background: linear-gradient(90deg, #f9f7df, #e3f5f3); border-radius: 4px; height: 60px; line-height: 60px; text-align: center; font-weight: bold; font-size: 18px; color: #333333">
          患者手机号：{{ detailInfo.patientName }} <span style="letter-spacing: 4px; font-size: 20px">{{ detailInfo.phone }}</span>
        </div>
        <div style="font-size: 14px; color: #fd403b; margin-top: 10px">* 电话接诊时长：一次15分钟，接诊完成后请点击“完成接诊”按钮</div>
        <div v-if="detailInfo.userFinishState == 2" style="margin-top: 20px">{{ detailInfo.userFinishRemark }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contactDialog = false">取 消</el-button>
        <el-button type="primary" @click="complateBtn()">完成接诊</el-button>
      </div>
    </el-dialog>
    <el-dialog title="回复评论" :visible.sync="dialogFormVisible" width="500px">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item prop="replyContent">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="form.replyContent" autocomplete="off"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveReplyBtn('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { DoctorAppointment } from "../../../components/DrugDomain/DoctorAppointment.js";
import { Chathub } from "../../../components/HospitalDomain/Chathub";
export default {
  data() {
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    var userChat = new Chathub(this.TokenClient, this.Services.Chathub);
    return {
      DoctorAppointment: doctorAppointment,
      UserChat: userChat,
      headers: { "Content-Type": "multipart/form-data;charset=UTF-8" },
      tableData: [],
      pageIndex: 1,
      dataTotal: 1,
      pageSize: 15,
      setDialog: false,
      DialogTitle: "添加银行卡",
      bankCardForm: {
        userName: "",
        cardNo: "",
        bankName: "",
        isDefault: false,
        oranizationId: null,
        operationUserId: null,
      },
      searchForm: {
        keyWord: "",
        datepicker: "",
        startTime: "",
        endTime: "",
        states: "-999",
        payType: "-1",
        orderType: 2,
        star: 0,
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      statusOption: [
        {
          value: "-999",
          label: "全部",
        },
        {
          value: "1",
          label: "待接诊",
        },
        {
          value: "2",
          label: "接诊中",
        },
        {
          value: "3",
          label: "已完成",
        },
        {
          value: "-1",
          label: "已取消",
        },
        {
          value: "-2",
          label: "已退款",
        },
        {
          value: "-3",
          label: "医生拒绝接诊",
        },
        {
          value: "-4",
          label: "删除",
        },
        {
          value: "5",
          label: "评价管理",
        },
      ],
      optionsPayType: [
        {
          value: "-1",
          label: "全部",
        },
        {
          value: "0",
          label: "余额",
        },
        {
          value: "1",
          label: "微信",
        },
        {
          value: "2",
          label: "支付宝",
        },
      ],
      title: "余额明细",
      DataCount: 0,
      json_fields: {
        订单编号: {
          filed: "key",
          callback: (val) => {
            return "NO：" + val.key;
          },
        },
        当前余额: "name",
      },
      fileList: [],
      rules: {
        refuseReson: [{ required: true, message: "请填写拒绝接诊原因", trigger: "blur" }],
        replyContent: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      refuseForm: {
        id: 0,
        refuseReson: "",
      },
      refuseDialog: false,
      formLabelWidth: "15px",
      detailInfo: {},
      contactDialog: false,
      texts: ["差评", "差评", "中评", "中评", "好评"],
      texts1: ["不满意", "一般", "满意", "很满意"],
      texts2: ["不及时", "一般", "及时", "很及时"],
      dialogFormVisible: false,
      form: {
        id: 0,
        replyContent: "",
        // replyUserId: 0,
        // replyUserName: "",
      },
      isLoad: false,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      isChatDiseaseUser: false,//当前用户是否是问诊客服
    };
  },
  mounted() {
    if (this.ClientId == this.YunClient || this.ClientId == this.AssociationClient || this.ClientId == this.FairClient) {
      this.getChatDiseaseUser();
    }
    this.getList();
  },
  methods: {
    getChatDiseaseUser() {
      var _this = this;
      _this.UserChat.GetOrganizationChatDiseaseIds(
        function (data) {
          let userIds = data.data;
          if (userIds && userIds.length > 0) {
            let res = userIds.filter((i) => i == _this.userInfo.id);
            if (res.length > 0) {
              _this.isChatDiseaseUser=true
            }
          } else {
            _this.$message({
              type: "error",
              message: "暂无问诊客服，请前往系统设置/管理员管理设置问诊客服！",
            });
          }
        },
        function (err) {
          console.log(err);
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    ReplyBtn(item) {
      this.form = {
        id: item.id,
        replyContent: "",
        // replyUserId: item.doctorId,
        // replyUserName: item.doctorName,
      };
      this.dialogFormVisible = true;
    },
    delBtn(item) {
      var _this = this;
      this.$confirm("确定删除该评论?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _this.DoctorAppointment.DeleteEvaluate(
            item.id,
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              _this.pageIndex = 1;
              _this.getList();
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {});
    },
    saveReplyBtn(formName) {
      var _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.DoctorAppointment.SubmitEvaluateReply(
            _this.form,
            function (data) {
              _this.dialogFormVisible = false;
              _this.pageIndex = 1;
              _this.getList();
            },
            function (err) {
              console.log(err);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toRefund(item) {
      this.refuseDialog = true;
      this.refuseForm = {
        id: item.orderNumber,
        refusalReason: "",
        state: item.state,
      };
    },
    SaveBtn(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.isLoad = true;
          var item = _this.refuseForm;
          if (item.state == 1) {
            _this.DoctorAppointment.RefuseOrder(
              item.id,
              item.refuseReson,
              function (data) {
                _this.isLoad = false;
                _this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                _this.$refs[formName].resetFields();
                _this.refuseDialog = false;
                _this.getList();
              },
              function (err) {
                _this.isLoad = false;
                var jsonObj = JSON.parse(err.msg);
                if (jsonObj.code == "400") {
                  _this.$message({
                    type: "error",
                    message: jsonObj.msg,
                  });
                }
              }
            );
          } else {
            _this.DoctorAppointment.AbortOrder(
              item.id,
              item.refuseReson,
              function (data) {
                _this.isLoad = false;
                _this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                _this.$refs[formName].resetFields();
                _this.refuseDialog = false;
                _this.getList();
              },
              function (err) {
                _this.isLoad = false;
                var jsonObj = JSON.parse(err.msg);
                if (jsonObj.code == "400") {
                  _this.$message({
                    type: "error",
                    message: jsonObj.msg,
                  });
                }
              }
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    CloseBtn(formName) {
      this.$refs[formName].resetFields();
      this.refuseDialog = false;
    },
    complateBtn() {
      var _this = this;
      _this.DoctorAppointment.DoctorCompleteOrder(
        _this.detailInfo.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          _this.contactDialog = false;
          _this.getList();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    toContact(item) {
      var _this = this;
      _this.getList();
      _this.UserChat.AddToChatDiseaseGroup(
        item.userId,
        item.orderNumber,
        item.doctorName,
        item.doctorId,
        function (data) {
          _this.$set(item, "groupId", data.data);
          _this.$bus.$emit("showDialog", item);
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          // if (jsonObj.code == "400") {
          _this.$message({
            type: "error",
            message: jsonObj.msg,
          });
          // }
        }
      );
    },
    toConfirm(item) {
      var _this = this;
      _this.DoctorAppointment.ConfirmOrder(
        item.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功!",
          });
          _this.getList();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    changeType(item) {
      this.searchForm.states = item.value;
      this.pageIndex = 1;
      this.getList();
    },
    toOrderInfo(item) {
      this.$router.push({
        path: "./ConsultationInfo",
        query: {
          type: 2,
          orderId: item.orderNumber,
        },
      });
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getList();
    },
    getList() {
      var _this = this;
      _this.tableData = [];
      var item = _this.searchForm;
      if (_this.searchForm.datepicker) {
        item.startTime = _this.searchForm.datepicker[0] + " 00:00:00";
        item.endTime = _this.searchForm.datepicker[1] + " 23:59:59";
      } else {
        item.startTime = "";
        item.endTime = "";
      }
      if (this.searchForm.states == 5) {
        _this.DoctorAppointment.GetOrganizationConsultationEvaluatePage(
          2,
          item.startTime,
          item.endTime,
          item.star,
          item.keyWord,
          this.pageIndex,
          this.pageSize,
          function (data) {
            _this.tableData = data.data.results;
            _this.pageIndex = data.data.pageIndex;
            _this.pageSize = data.data.pageSize;
            _this.dataTotal = data.data.dataTotal;
          },
          function (err) {
            console.log(err);
          }
        );
      } else {
        _this.DoctorAppointment.GetOrgOrderList(
          item.states,
          item.startTime,
          item.endTime,
          item.orderType,
          item.payType,
          item.keyWord,
          this.pageIndex,
          this.pageSize,
          function (data) {
            _this.tableData = data.data.results;
            _this.pageIndex = data.data.pageIndex;
            _this.pageSize = data.data.pageSize;
            _this.dataTotal = data.data.dataTotal;
          },
          function (err) {
            console.log(err);
          }
        );
      }
    },
    Search(event) {
      this.pageIndex = 1;
      this.getList();
    },
  },
};
</script>

<style scoped>
.center-content {
  height: calc(100% - 55px);
}
.iq-card-body {
  margin-top: 15px;
}
.typeBtn {
  padding-left: 20px;
  padding-right: 20px;
}
.dialog-form {
  width: 85%;
}

.iq-search-bar ::v-deep .el-rate {
  font-size: 35px;
}
</style>
